import get from 'lodash.get';
import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { PAGE_SIZE } from '~/modules/common/const';
import { PROJECT_EXECUTION_PHASE } from '~/modules/common/enums/ProjectExecutionPhase';

export const PROJECT_DROPDOWN_QUERY = gql`
  query ProjectDropdownSearch($filter: ProjectFilter2, $pagesize: Int) {
    projects(page: 1, pagesize: $pagesize, projectFilter: $filter) {
      id
      displayText
      status {
        uri
      }
    }
  }
`;

export const useProjectDropdownOptions = ({ filter }) => {
  const { data, loading } = useQuery(PROJECT_DROPDOWN_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter,
      pagesize: PAGE_SIZE + 1
    },
    context: {
      debounceKey: 'project-search',
      debounceTimeout: 250
    }
  });

  const projects = loading
    ? []
    : get(data, 'projects', []).map(project => ({
        ...project,
        isClosed: project.status?.uri === PROJECT_EXECUTION_PHASE.ARCHIVED
      }));

  return {
    projects,
    loading,
    hasMore: projects.length > PAGE_SIZE
  };
};

export default useProjectDropdownOptions;
